<script setup lang="ts">
/** Appendix B — Others as BO (Corporate signatory). */
import BoAppendixDocVarField from './BoAppendixDocVarField.vue';
import BoParticularsTable from './parts/BoParticularsTable.vue';
import BoCriteriaBlock from './parts/BoCriteriaBlock.vue';
import BoAppendixSigners from './parts/BoAppendixSigners.vue';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title">Appendix B</p>
    <p class="doc-p" style="text-align:center; margin-top:-4px">(Particulars of others as beneficial owner)</p>

    <p class="doc-lbl-title">1. The beneficial ownership information:</p>
    <BoParticularsTable key-prefix="ba02_" />
    <BoCriteriaBlock doc-code="BA02" key-prefix="ba02_" />

    <p class="doc-p" style="padding-top:14px">We hereby declare as follows:</p>
    <p class="doc-p" style="font-style:italic; padding-left:8px">
      “We hereby confirmed that the facts and information stated in this letter are true and to the best of our knowledge and belief.”
    </p>
    <BoAppendixSigners var-key="BA02" />
    <p class="doc-p" style="padding-top:4px">
      <BoAppendixDocVarField field-key="signer_designation_BA02" /><br />
      For and on behalf of<br />
      <BoAppendixDocVarField field-key="ba02_member_name" />
      (Company Registration No. <BoAppendixDocVarField field-key="ba02_member_registration_no" />)
    </p>
  </div>
</template>

<style src="./boAppendixDoc.css"></style>
